import { atom } from "recoil"
import localStorageEffect from "../libs/localStorageEffect"

const currentUser = atom({
  key: "user_state",
  default: {
    id: 0,
    associations: [],
    email: "",
    email_verified: false,
    firstName: "",
    lastName: "",
    isLoggedIn: false,
    phone: "",
  },
  effects_UNSTABLE: [localStorageEffect("user_state")],
})

export default currentUser
